import type { FC } from 'react';

import { Container, DeleteIcon, Label } from './styled';

import { Sizes } from '../../constants/sizes';
import { Clickable } from '../Clickable';

interface ITag {
    onDelete?: (value: string | number) => void;
    value: string | number;
    className?: string;
    size?: Sizes;

    /**
     * Used in FA app to keep the original style
     * @deprecated
     */
    legacyStyle?: boolean;
}

export const Tag: FC<ITag> = ({
    onDelete,
    value,
    size,
    className,
    legacyStyle,
}) => (
    <Container
        className={className}
        legacyDesign={legacyStyle}
        isClickable={Boolean(onDelete)}
    >
        <Label size={size} legacyDesign={legacyStyle}>
            {value}
        </Label>
        {onDelete && (
            <Clickable
                data-test={`Tag-${value}`}
                onClick={() => onDelete(value)}
            >
                <DeleteIcon legacyDesign={legacyStyle} />
            </Clickable>
        )}
    </Container>
);

Tag.defaultProps = {
    onDelete: undefined,
    className: '',
    size: Sizes.XL,
    legacyStyle: false,
};
